import { FieldLabel } from "@braze/beacon-core";
import { Select } from "@braze/beacon-lab-select";
import { FieldProps } from "./types";
import { FormContainer } from "./FormContainer";

interface OptionalSelectProps extends FieldProps {
  options: any[];
  info?: string;
}

/**
 * OptionalSelect component
 * Renders a select input field that is not required for form submission
 * Mirrors the behavior of RequiredSelect without validation constraints
 */
export const OptionalSelect = (props: OptionalSelectProps) => {
  return (
    <FormContainer>
      <FieldLabel label={props.name}>
        <Select
          fluid
          options={props.options}
          placeholder={`Select ${props.name.toLowerCase()}`}
          onChange={(selectedOption) => {
            props.handleChange(selectedOption);
          }}
          aria-label={props.name}
        />
      </FieldLabel>
    </FormContainer>
  );
};
